import { createBrowserRouter } from 'react-router-dom';
import { MONS_ROUTE_BASE, IS_BEHIND_MONS } from 'src/constants';
import { homeRouteGroups } from 'src/routes/home/routeTree';
import { valueMatchingRouteGroups } from 'src/routes/valueMatching/routeTree';
import { mpcsRouteGroups } from 'src/routes/mpcs/routeTree';

// Behind Mons the router uses a basename, so bare '/' matches nothing. Rewrite
// it to the mount point before the router reads the URL: '/' -> HomePage.
const redirectRootToMonsBase = (): void => {
  if (IS_BEHIND_MONS && window.location.pathname === '/') {
    const { search, hash } = window.location;
    window.history.replaceState(null, '', `${MONS_ROUTE_BASE}${search}${hash}`);
  }
};

redirectRootToMonsBase();

// Each domain exports a `*RouteGroups` array — spread one line per domain.
const router = createBrowserRouter(
  [
    ...homeRouteGroups,
    ...valueMatchingRouteGroups,
    ...mpcsRouteGroups,
  ],
  {
    ...(IS_BEHIND_MONS && { basename: MONS_ROUTE_BASE }),
  }
);

export default router;
